<template>
  <el-drawer title="区位列表" :visible.sync="drawer" :direction="direction" append-to-body :size="deawerSize"
    @close="closeDrawer">
    <div class="wrap">
      <el-form :model="searchParams">
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="100px" label-position="left" class="fromItem">
              <el-input v-model="searchParams.name" placeholder="请输入区位名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col style="margin-left: 15px" :span="15">
            <el-button type="primary" @click="getList">搜索</el-button>
            <el-button type="primary" @click="reset">重置</el-button>
            <el-button type="primary" @click="handleAdd">+添加区位</el-button>
            <el-button type="primary" @click="printAll">批量打印</el-button>
            <el-button type="primary" @click="sync" v-if=" companyName.includes('利佳')">重置排序</el-button>
          </el-col>
        </el-row>
      </el-form>
      <commonTable style="height:700px;overflow-y:auto;" :tableData="tableData" :total="total"
        :currentPage="queryParam.pageNum" @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange">
        <template v-slot:table>
          <el-table-column prop="name" align="center" label="区位名称" />
          <el-table-column prop="code" align="center" label="区位二维码">
            <template slot-scope="scope">
              <div :id="`codeImage${scope.row.id}`">
                <vue-qr :size="200" :margin="10" :auto-color="true" :dot-scale="1"
                  :text="`${codeUrl}?warehouse=${scope.row.id}`" />
                <div style="font-size: 12px;font-weight: bold">{{scope.row.fullName}}</div>
              </div>
            </template>
          </el-table-column>

          <!--          <el-table-column-->
          <!--              prop="name"-->
          <!--              align="center"-->
          <!--              label="数量"-->
          <!--          >-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button type="text" @click="codeDetail(scope.row,0)">{{scope.row.num||'0'}}</el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="storeNum" align="center" label="容器数量">
            <template slot-scope="scope">
              <el-button type="text" @click="codeDetail(scope.row,0)">{{scope.row.storeNum||'0'}}</el-button>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--              prop="name"-->
          <!--              align="center"-->
          <!--              label="重量"-->
          <!--          >-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-button type="text" @click="codeDetail(scope.row,1)">{{scope.row.weight||'0'}}</el-button>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="sorting" align="center" label="排序" />
          <el-table-column prop="createTime" align="center" label="创建时间" />
          <el-table-column align="center" width="200" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="downTwo(scope.row)">下载二维码</el-button>
              <el-button type="text" @click="editTwo(scope.row)">编辑</el-button>
              <el-button type="text" @click="delTwo(scope.row)" style="color: red">删除</el-button>
              <el-button type="text" @click="addCode(scope.row)">新建容器码</el-button>
              <el-button type="text" @click="printBtn(scope.row)">打印</el-button>
            </template>
          </el-table-column>
        </template>
      </commonTable>
    </div>

    <add-code-dialog ref="addCode" @getList="getList"></add-code-dialog>

    <add-dialog ref="addDialog" @getLocation="getList"></add-dialog>

    <el-dialog title="详情" :visible.sync="dialogTableVisible" modal-append-to-body append-to-body>
      <el-table :data="gridData">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div v-for="(index,item) in scope.row.classVos" :key="index">
              <el-row :gutter="24">
                <el-col :span="6">
                  {{item.className}}
                </el-col>
                <el-col :span="6">
                  {{item.num}}
                </el-col>
                <el-col :span="8">
                  {{item.weight}}
                </el-col>
              </el-row>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="name" label="容器名称" align="center"></el-table-column>
        <el-table-column property="className" label="容器码" align="center">
          <template slot-scope="scope">
            <vue-qr :id="`codeImage${scope.row.handle}`" :size="50" :margin="0" :auto-color="true" :dot-scale="1"
              :text="`${codeUrl}?h=${scope.row.handle}`" />
          </template>
        </el-table-column>
        <el-table-column v-if="numShow" property="num" label="数量" align="center"></el-table-column>
        <!--        <el-table-column property="className" label="类别" align="center"></el-table-column>-->
        <el-table-column v-if="!numShow" property="weight" label="重量(t)" align="center"></el-table-column>
      </el-table>
    </el-dialog>
    <store-code ref="code"></store-code>

    <code-print ref="codePrint"></code-print>
  </el-drawer>

</template>

<script>
  import VueQr from "vue-qr";
  import { get } from "@/utils/request";
  import commonTable from "@/components/common/commonTable";
  import AddDialog from "./AddDialog.vue";
  import html2canvas from "html2canvas";
  import { deleteWarehouse, fetchWarehouseDetail, updateSorting, updateContainerSorting, updateContainerSorting1 } from '@/api/storeWarehouse.js'
  import AddCodeDialog from "../../storeCode/component/AddCodeDialog.vue";
  import StoreCode from "./storeCode.vue";
  import CodePrint from "./codePrint.vue";
  import { codeUrl } from '@/utils/constant'
  export default {
    components: { CodePrint, StoreCode, VueQr, commonTable, AddDialog, AddCodeDialog },
    data() {
      return {
        drawer: false,
        direction: 'rtl',
        deawerSize: 1000,
        tableData: [],
        parentItem: '',
        total: 1,
        queryParam: {
          pageSize: 10,
          pageNum: 1,
          type: 2,
          parentId: 0,
          search: '',
          name: ''
        },
        searchParams: {
          name: ''
        },
        dialogTableVisible: false,
        gridData: [],
        numShow: true,
        codeUrl: codeUrl,
        userInfo: '',
        companyName: '',
      };
    },
    created() {
      let userInfo = JSON.parse(localStorage.getItem('info'));
      this.userInfo = userInfo
      if (this.userInfo.companyList) {
        this.companyName = this.userInfo.companyList[0].companyName
      }
    },
    methods: {
      async sync() {
        try {
          // 直接获取所有数据，避免两次查询
          const res = await get('/store/warehouse/page', {
            ...this.queryParam,
            pageNum: 1,
            pageSize: 999999, // 设置一个足够大的数值以获取所有数据
            parentId: this.parentItem.id,
            name: this.searchParams.name
          });

          const allTableData = res.list;

          // 构建需要更新排序的数据列表
          const sortList = allTableData.map((row, index) => ({
            id: row.id,
            sorting: index + 1 // 全局排序从1开始
          }));

          console.log("全部数据排序列表:", sortList);

          let params = {
            syncCodeList: sortList,
            id: 1
          };

          await updateSorting(params);

          this.$message.success('排序重置成功');
          this.getList(); // 重新获取当前页数据

        } catch (error) {
          console.error(error);
          this.$message.error('排序重置失败，请重试');
        }
      },
      addCode(row) {
        this.$refs.addCode.openDialog(row)
      },
      handleClose(done) {

      },
      reset() {
        this.searchParams.name = ''
        this.getList()
      },
      openDialog(item) {
        this.parentItem = item
        this.getList()
        this.drawer = true
      },
      getList() {
        this.queryParam.parentId = this.parentItem.id
        this.queryParam.name = this.searchParams.name
        get('/store/warehouse/page', this.queryParam).then(res => {
          this.tableData = res.list
          this.total = res.total
        })
      },
      handleSizeChange(num) {
        this.queryParam.pageSize = num
        this.queryParam.pageNum = 1
        this.getList();
      },
      handleCurrentChange(num) {
        this.queryParam.pageNum = num
        this.getList();
      },
      handleAdd(row) {
        this.$refs.addDialog.openDialog('add', { type: 2, parentId: this.parentItem.id })
      },
      editTwo(row) {
        this.$refs.addDialog.openDialog('edit', row)
      },
      downTwo(row) {
        let dom = document.getElementById('codeImage' + row.id);

        html2canvas(dom, { scale: 4 }).then(canvas => {
          let dataURL = canvas.toDataURL("image/png");
          if (dataURL !== "") {
            let a = document.createElement('a')
            a.download = row.name + '.png';
            a.href = dataURL;
            a.click()
          }
        })
      },
      delTwo(data) {
        let params = {
          id: data.id
        }
        this.$confirm('此操作将永久删除该区位, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteWarehouse(params).then(res => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList()
            }
          })
        }).catch(() => {

        });
      },
      closeDrawer() {
        this.$emit('getList')
      },
      codeDetail(row, flag, name) {
        this.$refs.code.openDialog(row, flag, this.parentItem.fullName)
      },
      printBtn(data) {
        this.$refs.codePrint.visiblePrint = true
        this.$refs.codePrint.init('', data.id)
      },
      printAll() {
        this.$refs.codePrint.visiblePrint = true
        this.$refs.codePrint.init(this.parentItem.id, '')
      },
    }
  };
</script>
<style scoped>
  .wrap {
    padding: 20px;
  }

  img {
    width: 50px;
    height: auto;
  }
</style>